module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_St_Maurice-c7bfa910730bcb55a8889e26c5520f7e.svg";